import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import * as Icons from "lucide-react";

export default function Modules() {
  const [mods, setMods] = useState([]);
  useEffect(() => { api.get("/modules").then((r) => setMods(r.data.modules)); }, []);

  return (
    <div className="p-8 space-y-6" data-testid="modules-page">
      <div>
        <div className="overline text-primary">/ MODULE MARKETPLACE</div>
        <h1 className="font-display text-4xl font-bold tracking-tight mt-2">
          Industry Modules
        </h1>
        <p className="text-sm text-muted-foreground mt-1 max-w-2xl">
          Activate only what you need. Every module ships with SOPs, dashboards, and AI assistance.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-0 border border-border">
        {mods.map((m, i) => {
          const Icon = Icons[m.icon] || Icons.Box;
          return (
            <Link
              key={m.id}
              to={`/app/modules/${m.id}`}
              className={`p-6 bg-card hover:bg-secondary transition-colors border-border block
                ${i % 4 !== 3 ? "lg:border-r" : ""}
                ${i % 3 !== 2 ? "sm:border-r lg:border-r-0" : ""}
                border-b`}
              data-testid={`module-${m.id}`}
            >
              <div className="flex items-start justify-between">
                <Icon className="w-6 h-6 text-primary" />
                <span className="text-[10px] font-mono-plex uppercase tracking-widest text-muted-foreground">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <div className="mt-6 font-display font-bold text-lg">{m.name}</div>
              <div className="text-sm text-muted-foreground mt-1 leading-relaxed">{m.desc}</div>
              <div className="mt-6 overline text-primary">◉ Open →</div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
